<template>
  <div class="about">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title">Login</h3>
            <div class="box">
              <div v-if="loginError" class="notification is-danger">
                Sorry, an error occured during login:
                <br />
                {{ loginErrorMsg }}
              </div>

              <div v-if="loginAttemptSuccess" class="notification is-success">
                Hurray, great to see you. One step is left. We sent you a email
                with an activation link and you need to confirm your account.
                Check your SPAM folder too.
              </div>
              <form @submit.prevent="attemptLogin">
                <div class="field">
                  <div class="control">
                    <input
                      v-model="email"
                      required
                      class="input"
                      type="email"
                      placeholder="Your Email"
                      autofocus
                      autocomplete="email"
                    />
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      v-model="password"
                      required
                      class="input"
                      type="password"
                      placeholder="Your Password"
                      autocomplete="current-password"
                    />
                  </div>
                </div>
                <button
                  v-bind:class="{ 'is-loading': loading }"
                  class="button is-block is-primary is-fullwidth"
                >
                  Login
                </button>
              </form>
            </div>
            <div class="field is-grouped is-grouped-centered has-text-grey">
              <p class="control">
                <router-link to="/register">Create Account</router-link>
              </p>
              <p class="control">
                <router-link to="/forgotpassword">Forgot Password</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import atomic from "atomicjs";
export default {
  name: "login",
  data: function () {
    return {
      loginError: false,
      loginErrorMsg: "",
      loginAttemptSuccess: false,
      password: null,
      email: null,
      loading: false,
    };
  },
  methods: {
    attemptLogin: function () {
      this.loginError = false;
      this.loading = true;
      var data = {
        email: this.email,
        password: this.password,
      };

      this.$store
        .dispatch("login", { email: this.email, password: this.password })
        .then((response) => {
          this.loading = false;
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          console.log("login error", error);
          this.loading = false;
          this.loginError = true;
          if (error.responseText.trim() == "ERROR_UNCONFIRMED_EMAIL") {
            this.loginErrorMsg = "Your email is not confirmed yet. Please follow the link in the email we sent you.";
          } else if (error.responseText.trim() == "ERROR_INVALID_USER_OR_PASSWORD") {
            this.loginErrorMsg = "Email and/or password are wrong"
          } else {
            this.loginErrorMsg = "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later."
          }
        });
    },
    attemptLoginOld: function () {
      this.loginError = false;
      this.loading = true;

      this.$store
        .dispatch("login", { email: this.email, password: this.password })
        .then(() => {
          this.loading = false;
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          this.loading = false;
          this.loginError = true;
          this.loginErrorMsg = error.json.error_description;
        });
    },
  },
};
</script>